<pp-modal [ppWide]="true" [ppNoPadding]="true">
  <ng-container heading> {{ headerText }} </ng-container>

  <ng-container body>
    <div class="newDashletCostFieldsWrapper">
      @if (ppNewDashlet()) {
        <div class="newDashletValueBreakdown__backWrapper">
          @if (ppNewDashlet()) {
            <div class="newDashletCostFieldsWrapper__back" (click)="goBack()">
              <pp-icon
                [ppSrc]="EIconPath.ICON_LEFT_MENU_ARROW_BACK_18"
                ppColor="inherit"
                ppClass="setSize18"
              ></pp-icon>
              <span> {{ 'back_to_dashlets' | ppTranslate }}</span>
            </div>
          }
          <hr class="newDashletCostFieldsWrapper__backLine" />
        </div>
      }

      @if (errorMessages.length > 0) {
        <pp-error-box [ppErrors]="errorMessages"></pp-error-box>
      }

      <div class="newDashletValueBreakdownFields">
        <div class="newDashletValueBreakdownFields__sitePickerWrapper">
          <h3 class="newDashletValueBreakdownFields__sitePickerTitle">
            {{ 'dashlet_value_breakdown' | ppTranslate }}
          </h3>

          <input
            type="text"
            class="newDashletValueBreakdownFields__customNameInput"
            [(ngModel)]="customName"
            [placeholder]="'rename_dashlet_placeholder' | ppTranslate"
            (ngModelChange)="checkErrors()"
          />
        </div>

        <div class="newDashletValueBreakdownFields__sitePickerWrapper">
          <h3 class="newDashletValueBreakdownFields__sitePickerTitle">
            {{ 'select_site' | ppTranslate }}
          </h3>

          <pp-new-dashlet-modal-value-breakdown-fields-site-picker
            [ppAssetId]="ppAssetId()"
            [ppSelectedAssetSite]="selectedRange.workspaceId"
            (ppSelectSite)="selectSite($event)"
          ></pp-new-dashlet-modal-value-breakdown-fields-site-picker>
        </div>

        <pp-new-dashlet-modal-value-breakdown-fields-custom-field-picker
          [(ppListFieldId)]="selectedRange.listCustomFieldId"
          [(ppNumericalFieldId)]="selectedRange.numericalCustomFieldId"
          [ppWorkspaceId]="selectedRange.workspaceId"
          (ppListFieldIdChange)="checkErrors()"
          (ppNumericalFieldIdChange)="checkErrors()"
        ></pp-new-dashlet-modal-value-breakdown-fields-custom-field-picker>
      </div>
    </div>
  </ng-container>

  <ng-container footer>
    @if (ppNewDashlet()) {
      <pp-button-modal-cancel (ppAction)="hideModal()">
        {{ 'cancel' | ppTranslate }}
      </pp-button-modal-cancel>
    }

    @if (!ppNewDashlet()) {
      <button class="deleteDashletButton" (click)="deleteDashlet()">
        <pp-icon [ppSrc]="EIconPath.ICON_BIN_14" ppClass="setSize14" ppColor="inherit"></pp-icon>
        {{ 'delete_dashlet' | ppTranslate }}
      </button>
    }

    <pp-button-modal-confirm ppTooltip (ppAction)="addDashlet()" [ppDisabled]="isDisabled">
      {{ confirmButtonText }}
    </pp-button-modal-confirm>
  </ng-container>
</pp-modal>
